import request from "../../utils/other/request.js"

// 获取当前用户购物车商品数量
export function getCartNum() {
    return request({
        url:'/sqsm/shop-car/showProAmount',
        method:'get',
    })
}
